// AssetImage — an <img> that walks an ordered candidate list (regional
// variant → neutral) on error and renders a fallback node when every
// candidate 404s. The whole regional-art system degrades through this:
// missing files can never break the UI.

import { useState, useEffect, type ReactNode, type CSSProperties } from 'react'

export interface AssetImageProps {
  /** Ordered candidate URLs; the first that loads wins */
  sources: string[]
  alt: string
  fallback: ReactNode
  loading?: 'lazy' | 'eager'
  style?: CSSProperties
}

export function AssetImage({ sources, alt, fallback, loading = 'lazy', style }: AssetImageProps) {
  const [index, setIndex] = useState(0)
  const key = sources.join('|')

  // New candidate list (level/region change) → start over from the first
  useEffect(() => { setIndex(0) }, [key])

  if (index >= sources.length) return <>{fallback}</>

  return (
    <img
      src={sources[index]}
      alt={alt}
      loading={loading}
      style={style}
      onError={() => setIndex(i => i + 1)}
    />
  )
}
